export enum EligibleJobStatusApi {
  OPEN = 'open',
  PENDING_COUNTER = 'pending-counter',
}

export interface IEligibleJobApi {
  id: string;
  status: EligibleJobStatusApi;
  local_date: string;
  local_end_time: string;
  local_start_time: string;
  local_timezone: string;
  professionName: string;
  specialty: string;
}

export interface IGetEligibleJobsApiResponse {
  response: IEligibleJobApi[];
  page: number;
  limit: number;
  total: number;
}
